<div class="help-info" [class.hidden]="hidden">
  @if (!titlecase) {
    <span>{{ errorMessage }}</span>
  }
  @if (titlecase) {
    <span>{{ errorMessage | titlecase }}</span>
  }
</div>
